
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/empreendimento/[id]",
      function () {
        return require("private-next-pages/empreendimento/[id]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/empreendimento/[id]"])
      });
    }
  